import { Component, OnInit } from '@angular/core';
import { GetStartedService } from 'app/website/services/get-started.service';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class SitePricingComponent implements OnInit {

  constructor(private getStartedService: GetStartedService,private ecoDocsTitleService: EcoDocsTitleService) {

   }

   choosePlan(planName){
    this.getStartedService.choosePlan(planName)
   }

  ngOnInit() {
    this.ecoDocsTitleService.setTitle('EcoDocs Pricing and Plans', false);
  }
  pricingComaprison = [
    {
      sectionHeader: 'Users & Teams',
      comparison: [
        {
          comparisonTitle: 'Add users',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Create teams',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Add contacts (external users)',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Set access permissions',
          small: true,
          medium: true,
          advanced: true
        }
      ]
    },
    {
      sectionHeader: 'Document Management & Collaboration',
      comparison: [
        {
          comparisonTitle: 'EcoDocs Cloud',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Compliant infrastructure (SOC, PCI DSS, FedRAMP, HIPAA)',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'File management and sharing',
          small: true,
          medium: true,
          advanced: true
         },
         {
           comparisonTitle: 'Comments & collaboration',
           small: true,
           medium: true,
           advanced: true
          },
          {
            comparisonTitle: 'Auto backups & redundancy',
            small: true,
            medium: true,
            advanced: true
           },
           {
             comparisonTitle: 'Linking to on-premise data ',
             small: true,
             medium: true,
             advanced: true
            },
            {
              comparisonTitle: '3rd party cloud services integration ',
              small: true,
              medium: true,
              advanced: true
            },
            {
              comparisonTitle: 'Instant indexing',
              small: true,
              medium: true,
              advanced: true
            },
            {
              comparisonTitle: 'Full-textual search',
              small: true,
              medium: true,
              advanced: true
            }
      ]
    },
    {
      sectionHeader: 'E-Forms',
      comparison: [
        {
          comparisonTitle: 'Organization and grouping',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Drag-and-drop forms builder',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Import existing PDFs',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Basic form fields (Text, Numbers, Date...etc)',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Advanced form fields (Signature, Checkboxes, Picture...etc)',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Basic validation',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Custom validation logic',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Calculated values & formulas',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Conditional formatting',
          small: true,
          medium: true,
          advanced: true
        }
      ]
    },
    {
      sectionHeader: 'Workflow Automation',
      comparison: [
        {
          comparisonTitle: 'Ready-made customizable workflow templates',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Single-step workflows',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Approval workflows',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Review workflows',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Multi-step workflows',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Visual workflow template builder',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Clone  workflows',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Automatic actions (save, upload and email)',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Decision-based flow paths',
          small: true,
          medium: true,
          advanced: true
        }
      ]
    },
    {
      sectionHeader: 'Data Reports & Analytics',
      comparison: [
        {
          comparisonTitle: 'Custom Dashoards',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Charts',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Metrics',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Datatables',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Data Monitor and Alerts',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Insights and analytics',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Real-time access to data',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Export data to spreadsheets',
          small: true,
          medium: true,
          advanced: true
        },
        {
          comparisonTitle: 'Schedule reports',
          small: true,
          medium: true,
          advanced: true
        }
      ]
    },
    {
      sectionHeader: 'Document Capture & OCR',
      comparison: [
        {
          comparisonTitle: 'Capture & sort',
          small: false,
          medium: false,
          advanced: true
        },
        {
          comparisonTitle: 'OCR & text extraction',
          small: false,
          medium: false,
          advanced: true
        }
      ]
    },

  ]
}
